import { layout } from 'thewest/App.routing'
import { metrics } from 'component-library/__styling/settings'
import { BaseClientConfig } from 'common/client/BaseClientConfig'
import { noIndexMeta } from 'common/meta/common-tags'
import { StaticPageRoute, PageType, GetRouteAdTargeting } from 'common/routing/page-definition'
import { ErrorResolution, RouteResolution } from 'common/routing/route-resolver'
import { TheWestSections } from 'publication-types'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'

// Only for page not found
const recommended = layout.component({
    type: 'lima',
    props: {
        verticalSpacing: 'lg',
        fontScale: 1.2,
        fixedRatios: ['16:9'],
        initialColumns: 1,
        intermediateColumns: 2,
        finalColumns: 4,
        hideTeaser: true,
        hideByline: false,
        hasBackground: true,
        sectionHeader: {
            heading: 'Recommended',
            headingUrl: '/',
            section: 'default',
            navLinks: [],
        },
        dataDefinitionArgs: {
            type: 'curation',
            name: 'home',
            offset: 0,
            pageSize: 4,
        },
    },
})

export const outbrainAd = (config: BaseClientConfig) =>
    layout.component({
        type: 'outbrain-ad',
        props: {
            link: config.outbrainUrl,
            widgetId: 'AR_2',
            template: 'TheWestAustralian',
        },
    })

export const notFoundRoute: StaticPageRoute<typeof layout, TheWestSection> = ({
    config,
    getAdTargeting,
    resolution,
}) => {
    const section = ((resolution as ErrorResolution).section ||
        TheWestSections.default) as TheWestSection

    return {
        kind: 'page',
        heading: 'Page Not Found',
        pageMeta: {
            meta: [noIndexMeta],
        },
        // used by `/server/middleware/optimised-ssr` to determine redirect status
        pageType: 'not-found',
        hideHeading: true,
        adTargeting: getAdTargeting('error', section, 'page-not-found'),
        section,
        compositions: [
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth: metrics.thewest.mainContentWidth,
                    horizontalGutters: true,
                },
                contentAreas: {
                    main: [
                        {
                            type: 'breadcrumb',
                            props: {
                                title: 'Page not found',
                                verticalSpacing: 'md',
                            },
                        },
                        {
                            type: 'west-404-page',
                            props: {},
                        },
                        outbrainAd(config),
                        recommended,
                    ],
                },
            }),
        ],
    }
}

export const matchedSomethingWentWrongRoute = (
    config: BaseClientConfig,
    getAdTargeting: GetRouteAdTargeting,
    resolution: RouteResolution
): PageType<typeof layout, TheWestSection> =>
    somethingWentWrongContent(config, getAdTargeting, resolution)

export const staticSomethingWentWrongRoute: StaticPageRoute<typeof layout, TheWestSection> = ({
    config,
    getAdTargeting,
    resolution,
}) => somethingWentWrongContent(config, getAdTargeting, resolution)

const somethingWentWrongContent = (
    config: BaseClientConfig,
    getAdTargeting: GetRouteAdTargeting,
    resolution: RouteResolution
): PageType<typeof layout, TheWestSection> => {
    const section = ((resolution as ErrorResolution).section ||
        TheWestSections.default) as TheWestSection

    return {
        kind: 'page',
        heading: 'Something Went Wrong',
        pageMeta: {
            meta: [noIndexMeta],
        },
        pageType: 'something-went-wrong',
        hideHeading: true,
        adTargeting: getAdTargeting('error', section, 'something-went-wrong'),
        section,
        compositions: [
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth: metrics.thewest.mainContentWidth,
                    horizontalGutters: true,
                },
                contentAreas: {
                    main: [
                        {
                            type: 'breadcrumb',
                            props: {
                                title: 'Something Went Wrong',
                            },
                        },
                        {
                            type: 'west-500-page',
                            props: {},
                        },
                        outbrainAd(config),
                    ],
                },
            }),
        ],
    }
}
